"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapJazzbandDedupedResultIssues = void 0;
const mapJazzbandDedupedResultIssues = (result, unique) => {
    const { id, description, help, helpUrl, impact, tags, duplicates } = result;
    const mappedIssue = {
        ruleId: id,
        help,
        description,
        helpUrl,
        impact,
        isExperimental: false,
        isManual: false,
        needsReview: false,
        summary: unique.failureSummary,
        tags,
        createdAt: new Date(unique.created_at).toISOString(),
        isNewIssue: unique.isNewIssue
    };
    // look for attached metadata and user tags
    if (unique?.userTags) {
        mappedIssue.userTags = unique?.userTags;
    }
    if (unique?.metadata) {
        mappedIssue.metadata = unique?.metadata;
    }
    // mobile-specific check of the platform
    if (unique?.metadata?.platform?.name === 'iOS') {
        mappedIssue.mobilePlatform = 'Apple';
    }
    else if (unique?.metadata?.platform?.name === 'Android') {
        mappedIssue.mobilePlatform = 'Google';
    }
    // Check if we're rendering mobile, because while it has some of the same fields as HTML
    // (to reuse backend logic), we don't want to display all of them or they need to be
    // remapped to a different display field
    if (mappedIssue.mobilePlatform) {
        /*
         * Clarification: The reason we have to parse the value of unique.html
         * is that mobile doesn't define a node by an HTML/XML structure. Instead,
         * it's a JSON object that describes computed/static values. For example:
         * {
         *   "className": "RCTView",
         *   "controlWidth": 143,
         *   "controlHeight": 49,
         *   "boundsInScreen": {
         *     "top": 2542,
         *     "left": 856,
         *     "right": 1284,
         *     "bottom": 2688
         *   }
         * }
         * We are storing the stringified JSON in DedupedNode.html to reuse the
         * backend logic in Jazzband and avoid branching logic based on product.
         */
        mappedIssue.analyzedValues = JSON.parse(unique.html);
        mappedIssue.appIdentifier = unique?.metadata?.appIdentifier;
        mappedIssue.screenTitle = unique?.metadata?.screenTitle;
    }
    else {
        // all other display types
        mappedIssue.selector = unique.target;
        mappedIssue.source = unique.html;
        mappedIssue.testUrl = unique.url;
        if (unique.ancestry) {
            mappedIssue.ancestry = unique.ancestry;
        }
        if (unique.xpath) {
            mappedIssue.xpathSelector = unique.xpath;
        }
        if (unique.page_state) {
            mappedIssue.testPageTitle = unique.page_state;
        }
    }
    if (unique.fingerprints && unique.fingerprints[0]) {
        mappedIssue.duplicates = duplicates[unique.fingerprints[0]];
    }
    if (unique.advanced?.visibleBoundingRect) {
        mappedIssue.boundingBox = unique.advanced.visibleBoundingRect;
    }
    if (unique.screenshot_id) {
        mappedIssue.screenshotId = unique.screenshot_id;
    }
    return mappedIssue;
};
exports.mapJazzbandDedupedResultIssues = mapJazzbandDedupedResultIssues;
//# sourceMappingURL=mapJazzbandDedupedResultIssues.js.map